import React, { MutableRefObject } from 'react'
import classNames from 'classnames'
import { LinkButton } from '@/atoms/Button'
import { useOnScreen } from '@/utils/ScreenUtils'
import { useSafeAnalytics } from '@/utils/analytics'
import { useTranslate } from '@/utils/translate/translate-client'

interface Props {
  campaignSlug: string
  topCtaRef: MutableRefObject<null>
}

export const FixedMobileExpressInterestButton: React.FC<Props> = ({ campaignSlug, topCtaRef }) => {
  const { isIntersecting: topCtaIsVisible } = useOnScreen(topCtaRef)
  const { track } = useSafeAnalytics()

  const { t } = useTranslate('torches')
  const expressInterest = t('expressInterest', 'Express Interest')

  return (
    <div
      className={classNames('bg-white sticky 2lg:hidden bottom-0 px-6 py-4 shadow-inner shadow-gray-200', {
        hidden: topCtaIsVisible,
      })}
    >
      <LinkButton
        variant="oxide"
        href={`/torches/${campaignSlug}/express-interest`}
        className="mx-auto max-w-[420px]"
        onClick={() => track('Express Interest Button Clicked', { campaign: campaignSlug })}
      >
        {expressInterest}
      </LinkButton>
    </div>
  )
}
